<template>
  <div id="widgetapp">
    <transition name="fade" mode="out-in">
      <router-view class="main" v-cloak/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'widgetapp'
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/_all';
$navbar-height: 6.5rem;
$navbar-item-img-max-height: 10rem;

$white: hsl(0, 0%, 100%);
$black: hsl(0, 0%, 4%);
$light: hsl(0, 0%, 96%);
$light-invert: findColorInvert($light);
$dark: hsl(0, 0%, 21%);
$dark-invert: findColorInvert($dark);
$primary: #a6192e;
$primary-invert: findColorInvert($primary);
$link: hsl(217, 71%, 53%);
$link-invert: findColorInvert($link);
$info: hsl(204, 86%, 53%);
$info-invert: findColorInvert($info);
$success: hsl(141, 71%, 48%);
$success-invert: findColorInvert($success);
$warning: hsl(48, 100%, 67%);
$warning-invert: findColorInvert($warning);
$danger: hsl(348, 100%, 61%);
$danger-invert: findColorInvert($danger);
$secondary: #c9e9fd;
$secondary-invert: findColorInvert($secondary);

$colors: (
  'white': ($white, $black),
  'black': ($black, $white),
  'light': ($light, $light-invert),
  'dark': ($dark, $dark-invert),
  'primary': ($primary, $primary-invert),
  'info': ($info, $info-invert),
  'success': ($success, $success-invert),
  'warning': ($warning, $warning-invert),
  'danger': ($danger, $danger-invert),
  'secondary': ($secondary, $secondary-invert)
);

@import '~bulma';
@import '~buefy/src/scss/buefy';
@import '../node_modules/reset-css/reset.css';

@font-face {
  font-family: 'Newzald-Book';
  src: url('assets/Newzald-Book.otf');
}

@font-face {
  font-family: 'National-Extrabold';
  src: url('assets/National-Extrabold.otf');
}

@font-face {
  font-family: 'National-Light';
  src: url('assets/National-Light.otf');
}

#app {
  font-family: Newzald-Book, Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 100%;
  background: #f4f2ef;
}

.main {
  flex: auto;
}
</style>



// WEBPACK FOOTER //
// src/Widgetapp.vue